import type { FC, ReactNode } from 'react'
import { Layout } from '@/components/Layout/Layout'
import RadarHeader from '@/components/Radar/RadarHeader'

interface PageWithRadarHeaderProps {
  title?: string
  children: ReactNode
}

const PageWithRadarHeader: FC<PageWithRadarHeaderProps> = ({
  title,
  children
}) => (
  <>
    <RadarHeader title={title} />
    <Layout>{children}</Layout>
  </>
)

export default PageWithRadarHeader
